module.exports = __webpack_public_path__ + "static/media/noon.f07f2409.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/noon.svg
// module id = 872
// module chunks = 2